import { render, staticRenderFns } from "./UploadAnexos.vue?vue&type=template&id=7a112dfa&scoped=true&lang=pug&"
import script from "./UploadAnexos.vue?vue&type=script&lang=js&"
export * from "./UploadAnexos.vue?vue&type=script&lang=js&"
import style0 from "./UploadAnexos.vue?vue&type=style&index=0&id=7a112dfa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a112dfa",
  null
  
)

export default component.exports